import React, { Fragment, useCallback, useEffect, useMemo, useState } from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';
import { ResultOperation, Column, SelfTableList, FilterState, ListFields, usePermission, useTranslation } from '@np/np_webcomponentlib'
import { API_BUSINESS } from '../../shared/consts/api'

import { DataEntityType, initEntity, columnsForChoose, DataEntityTypeViewModel } from './RateTypes'

import { RateForm } from './RateForm'

import { ColumnEvent, ColumnWithCopyToClipboard, ColumnData } from '../../shared/entityOperations/EntityOperationsCustomFC'

import '../../shared/entityOperations/EntityOperations.css'




const RateList = ({ listFilterFieldProps }: { listFilterFieldProps: ListFields[] }) => {

  const { canView, canCreate, canUpdate, canRemove, debugMode } = usePermission('SpecificationcharacteristictypeList');

  const initialFilter: FilterState = {
    listFields: listFilterFieldProps,
    sort: null,
    searchData: '',
    take: 50,
    skip: 0,
  }

  const [idEdit, setIDEdit] = useState<string>("")

  const [forceUpdate, setForceUpdate] = useState<boolean>(false)

  const [show2, setShow2] = useState(false);
  const xtralargemodalClose = () => { setIDEdit(""); setShow2(false) };
  const xtralargemodalShow = () => setShow2(true);


  const dateAddedTitle = useTranslation('dateAdded');
  const dateUpdatedTitle = useTranslation('dateUpdated');

  const idrfSpecificationTitle = useTranslation('idrfSpecification');
  const idrfCharacteristicTypeTitle = useTranslation('idrfCharacteristicType');
  const isMandatoryTitle = useTranslation('isMandatory');


  const memoizedColumnsRate = useCallback(() => {
    const columnsSpecificationcharacteristictype: Column[] = [

      

      {
        title: '',
        listFields: null,
        type: 'custom',
        custom: (data: DataEntityType) => (

          <ColumnWithCopyToClipboard data={data.idUnique} title='fe fe-edit eventIcom'></ColumnWithCopyToClipboard>
        ),
        key: 1,
        withFilter: null,
        class: "eventColumn"
      },

      {
        title: '',
        listFields: null,
        type: 'custom',
        custom: (data: DataEntityType) => (

          <ColumnEvent idUnique={data.idUnique} event={handleEdit} title='fe fe-edit eventIcom'></ColumnEvent>
        ),
        key: 2,
        withFilter: null,
        class: "eventColumn"
      },

      {
        title: dateAddedTitle,
        listFields: {
          fieldName: 'dateAdded',
          comparison: 'containsStrong',
          listVal: [''],
        },
        type: 'date-time',
        key: 100,
        withFilter: 'onlySorted',
        class: "dateTtimeColumn"
      },


      {
        title: 'Наименование',
        listFields: {
            fieldName: 'title',
            comparison: 'containsIgnoreCase',
            listVal: [''],
        },
        key: 9,
        withFilter: 'all',
    },





        {
          title: dateUpdatedTitle,
          listFields: {
            fieldName: 'dateUpdated',
            comparison: 'containsStrong',
            listVal: [''],
          },
          type: 'date-time',
          key: 101,
          withFilter: 'onlySorted',
          class: "dateTtimeColumn"
        }
    ]
  

    // if (debugMode || canRemove) {
    //   columnsSpecificationcharacteristictype.push(
    //     {
    //       title: '',
    //       listFields: null,
    //       type: 'custom',
    //       custom: (data: DataEntityType) => (

    //         <DeleteEntity idUnique={data.idUnique} apiPath={`${API_PRODUCT}/catalogproduct`} onResult={onResultRemove}></DeleteEntity>
    //       ),
    //       key: 102,
    //       withFilter: null,
    //       class: "eventColumn"
    //     })
    // }
    return columnsSpecificationcharacteristictype
  }, [idrfSpecificationTitle, idrfCharacteristicTypeTitle, isMandatoryTitle, dateAddedTitle, dateUpdatedTitle, debugMode, canRemove])


  const handleEdit = (idUnigue: string) => {
    setIDEdit(idUnigue)
  }

  const onResultRemove = (result: ResultOperation) => {
    if (result.status === "success") {

      setForceUpdate(true)

      console.log("forceUpdate:", forceUpdate)
    }
  }

  useEffect(() => {
    if (forceUpdate) {
      setForceUpdate(false)
    }
  }, [forceUpdate])


  useEffect(() => {
    if (idEdit !== "") {
      xtralargemodalShow()
    }
  }, [idEdit])

  const getTitleModal = () => {
    if (idEdit === "")
      return "Создание"
    else
      return "Редактирование"
  }



  const docClientForm = useMemo(() => (
    <RateForm 
      title={getTitleModal()} 
      idInit={idEdit} 
      handleClose={xtralargemodalClose} 
      initEntityProps={listFilterFieldProps.length > 0 ? { ...initEntity, idClient: listFilterFieldProps[0].listVal[0] } : initEntity}
    />
  ), [show2]);

  return (
    <Fragment>

      {canCreate &&
        <Button variant="primary" onClick={xtralargemodalShow}><i className='fa fa-plus'></i>
        </Button>
      }

      <Modal size="xl" show={show2} onHide={xtralargemodalClose}>
        <ModalHeader>
          <ModalTitle as="h5"></ModalTitle>
          <span className="d-flex ms-auto" onClick={xtralargemodalClose}><i className='fe fe-x ms-auto' ></i></span>
        </ModalHeader>
        <ModalBody>
          {/* <DocClientForm title={getTitleModal()} idInit={idEdit} handleClose={xtralargemodalClose} initEntityProps={listFilterFieldProps.length > 0 ? { ...initEntity, idClient: listFilterFieldProps[0].listVal[0] } : initEntity}></DocClientForm> */}
          {docClientForm}
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={xtralargemodalClose}>
            Закрыть
          </Button>
        </ModalFooter>
      </Modal>

      {/* {show2 && <SessionForm title={"Создание/Редактирование"} idInit={null}></SessionForm>} */}


      {!show2 && listFilterFieldProps.length > 0 && <SelfTableList apiUrl={`${API_BUSINESS}raterepo/list`} columns={memoizedColumnsRate()} classProp='table table-striped' theadClassProp='table' forceUpdate={forceUpdate} initialFilterState={initialFilter} />}
      {!show2 && listFilterFieldProps.length == 0 && <SelfTableList apiUrl={`${API_BUSINESS}raterepo/list`} columns={memoizedColumnsRate()} classProp='table table-striped' theadClassProp='table' forceUpdate={forceUpdate} />}
    </Fragment>
  )
}


export default RateList